import { render, staticRenderFns } from "./EditDetail.vue?vue&type=template&id=2c1296c1&scoped=true&"
import script from "./EditDetail.vue?vue&type=script&lang=js&"
export * from "./EditDetail.vue?vue&type=script&lang=js&"
import style0 from "./EditDetail.vue?vue&type=style&index=0&id=2c1296c1&lang=less&"
import style1 from "./EditDetail.vue?vue&type=style&index=1&id=2c1296c1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1296c1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1296c1')) {
      api.createRecord('2c1296c1', component.options)
    } else {
      api.reload('2c1296c1', component.options)
    }
    module.hot.accept("./EditDetail.vue?vue&type=template&id=2c1296c1&scoped=true&", function () {
      api.rerender('2c1296c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/familyMotto/comp/EditDetail.vue"
export default component.exports